<template>

    <tab-list v-if="quote">
        <tab v-for="section in quote.children" v-if='section.type === "quote_section"' :key="section.id" :name="section.title">
            <sow-looper :items="section.children" v-if="section.children.length"></sow-looper>
        </tab>
    </tab-list>

</template>

<script>
    export default {
        props: ['quoteId'],
        data() {
            return {
                name: 'quote',
                quote: null
            }
        },
        filters: {},
        watch: {},
        computed: {},
        methods: {
            getScope() {
                this.quote = null;
                var that = this;
                var url = appUrls.quotes.show.replace('REPLACEME', this.quoteId);

                axios.get(url).then(response => {
                    that.quote = response.data.data;
                });
            }
        },
        mounted() {
            this.getScope();
        }
    }
</script>

<style lang="scss">
</style>
